import React from "react"
import classNames from "classnames"
import { SafeAreaView } from "@hg/layouts"

import styles from "./index.module.less"

interface IProps {
    type?: "light" | "dark"
    className?: string
    style?: React.CSSProperties
    onClick?: () => void
}

const Exit: React.FC<IProps> = (props) => {
    const { className, style, onClick } = props

    return (
        <SafeAreaView
            mode="margin"
            edges={["top", "right"]}
            className={classNames(styles.exit, className)}
            style={style}
            onClick={onClick}
        />
    )
}

export default Exit
